import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  //   CFormSelect,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
// import ReactPaginate from "react-js-pagination";
import { useSelector, useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { loanDisbursmentsReports } from "src/api/allApis";

const calculateEmiTotals = (loans) => {
  let totalPendingEmi = 0;
  let totalPaidEmi = 0;

  loans.forEach((loan) => {
    loan.emis.forEach((emi) => {
      if (emi.emiStatus === "pending") {
        totalPendingEmi += parseFloat(emi.emiAmount);
      } else if (emi.emiStatus === "paid") {
        totalPaidEmi += parseFloat(emi.emiAmount);
      }
    });
  });

  return { totalPendingEmi, totalPaidEmi };
};

const LoansReport = () => {
  const dispatch = useDispatch();

  const { loanDisbursmentDataReports } = useSelector(
    (state) => state?.interestsReducer
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [allCustomerData, setAllCustomerData] = useState([]);
  const [newData, setNewData] = useState(allCustomerData);
  const [showDetails, setShowDetails] = useState(false);

  const [showEmiDetails, setShowEmiDetails] = useState(true);
  const componentPDF = useRef();
  const [printState, setPrintState] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [currSelect, setCurrSelect] = useState("");

  const SchemaName = sessionStorage.getItem("schemaName");

  useEffect(() => {
    const obj = { schemaName: SchemaName };
    loanDisbursmentsReports(obj);
  }, []);

  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);

  const download_btn = () => {
    setPrintState(true);
  };

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const rowsPerPage = 10;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = allCustomerData?.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    setNewData(allCustomerData);
  }, [allCustomerData]);

  const handleSearch = () => {
    const data = allCustomerData
      ?.filter((ele) => ele.loans?.some((loan) => loan.status === currSelect))
      .map((ele) => ({
        ...ele,
        loans: ele.loans?.filter((loan) => loan.status === currSelect),
      }));
    setNewData(data);
  };
  const overallLoanDisbursmentAmount = (
    loanDisbursmentDataReports || []
  ).reduce((acc, item) => {
    return acc + (Number(item.DisbursementAmount) || 0);
  }, 0);

  return (
    <div className="content">
      <CCard>
        <CCardHeader>
          <div className="flex justify-between">
            <strong>Loan Details</strong>
            <div>
              <div>
                <CButton
                  className="add-btn mr-10 w-auto"
                  onClick={download_btn}
                >
                  Download
                </CButton>
                <CButton
                  className="add-btn m-0 w-auto"
                  onClick={() => setShowDetails(false)}
                >
                  Back
                </CButton>
              </div>

              {showEmiDetails === false ? (
                <CButton
                  className="add-btn m-0 w-auto"
                  onClick={() => setShowEmiDetails(true)}
                >
                  Back
                </CButton>
              ) : (
                ""
              )}
            </div>
          </div>
        </CCardHeader>
        <CCardBody>
          <div>
            <CRow
              style={{
                width: "-webkit-fill-available !important",
                alignItems: "end",
                justifyContent: "end",
              }}
            >
              <CCol xs={3}></CCol>
              {/* <CCol xs={3}>
                <div>
                  <span className="lable-name">Select Status :</span>
                  <CFormSelect
                    value={currSelect}
                    onChange={(e) => setCurrSelect(e.target.value)}
                  >
                    <option value={""}>Select Status</option>
                    <option value={"pending"}>Pending</option>
                    <option value={"reject"}>Reject</option>
                    <option value={"approved"}>Approved</option>
                    <option value={"open"}>Disbursment</option>
                  </CFormSelect>
                </div>
              </CCol> */}
              <CCol xs={3}>
                {/* <CButton onClick={handleSearch}>Search</CButton> */}
              </CCol>
            </CRow>
          </div>
          <div className="serch_bar"></div>
          <CCardHeader>
            <strong>
              Over Loan Disbursements:
              <span style={{ color: "blue" }}>
                {overallLoanDisbursmentAmount}
              </span>
            </strong>
          </CCardHeader>
          <div
            ref={printState ? componentPDF : null}
            style={{ padding: printState ? "20px" : "0px" }}
          >
            <div style={{ marginTop: "40px" }}>
              <CTable hover className="" responsive>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Sr No.</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Date</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Customer Name</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Father Name</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Disbursements</span>
                    </CTableHeaderCell>
                    {/* 
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Total Pending</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Total Paid</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col" className="">
                      <span className="">Loan Status</span>
                    </CTableHeaderCell> */}
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {loanDisbursmentDataReports?.length > 0 &&
                    loanDisbursmentDataReports?.map((company, index) => {
                      //   const { totalPendingEmi, totalPaidEmi } =
                      //     calculateEmiTotals(company?.loans || []);
                      return (
                        <CTableRow key={index}>
                          <CTableDataCell>{index + 1}</CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.DisbursementDate || "-"}
                          </CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {`${company.firstName} ${company.middleName} ${company.lastName}` ||
                              "-"}
                          </CTableDataCell>

                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.fatherName ? company?.fatherName : "-"}
                          </CTableDataCell>
                          <CTableDataCell style={{ cursor: "pointer" }}>
                            {company?.DisbursementAmount || "-"}
                          </CTableDataCell>
                          {/* <CTableDataCell>
                            </CTableDataCell>
                          <CTableDataCell>
                            </CTableDataCell>
                          <CTableDataCell>
                          </CTableDataCell> */}
                        </CTableRow>
                      );
                    })}
                </CTableBody>
              </CTable>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default LoansReport;
